// Safe localStorage wrapper. Uses localStorage (replacing window.storage).
// Returns null on any error so callers don't need try/catch everywhere.

const STORAGE_KEY = "sp500_scanner_v1";
const STORAGE_VERSION = 1;
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h — older data is considered stale

export function loadResults() {
  try {
    if (typeof localStorage === "undefined") return null;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== STORAGE_VERSION) return null;
    if (Date.now() - (parsed.scannedAt || 0) > MAX_AGE_MS) {
      // Stale — return but caller can decide whether to use
      return { ...parsed, stale: true };
    }
    return parsed;
  } catch (e) {
    console.warn("[storage] load failed:", e.message);
    return null;
  }
}

export function saveResults({ results, runCount, scannedAt, sector }) {
  try {
    if (typeof localStorage === "undefined") return false;
    const payload = {
      version: STORAGE_VERSION,
      results: results || [],
      runCount: runCount || 0,
      scannedAt: scannedAt || Date.now(),
      sector: sector || "ALL",
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return true;
  } catch (e) {
    console.warn("[storage] save failed:", e.message);
    // QuotaExceededError — try to clear old data and retry
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (_ignored) {
      /* nothing else to do */
    }
    return false;
  }
}

export function clearResults() {
  try {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn("[storage] clear failed:", e.message);
  }
}
